import React, { useState, useMemo } from 'react'; // MODIFIED: added useMemo
import '../../../App.css';
import '../Transactions.css';

import WorkforceApprover from './tabs/WorkforceApproverTab/WorkforceApprover';
import ApprovalPolicyTab from './tabs/ApprovalPolicyTab/ApprovalPolicyTab';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AmountThresholdTab from './tabs/AmountThresholdTab/AmountThresholdTab';
import { FEATURES } from '../../../config/features';
import FinancialApprover from '../../../v2/components/modules/FinancialApprover/FinancialApprover';
import EmployeeTransactionApprover from '../../../v2/components/modules/EmployeeTransactionApprover/EmployeeTransactionApprover';

function ApproverHierarchy({ user, userAccess, isHideSideMenu }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleSelectChange = (index) => {
    setSelectedTab(index);
  };

  // ADDED: Configuration-driven tab definitions
  // This array makes it easy to add, remove, or reorder tabs without touching the JSX structure
  const tabConfigs = useMemo(() => [
    {
      id: 'workforce',
      label: 'WORKFORCE APPROVERS',
      condition: true, // Always show
      component: <WorkforceApprover user={user} userAccess={userAccess} />
    },
    {
      id: 'financial',
      label: 'FINANCIAL APPROVERS',
      condition: FEATURES.APPROVER_HIERARCHY__FINANCIAL_APPROVERS,
      component: <FinancialApprover user={user} userAccess={userAccess} />
    },
    {
      id: 'thresholds',
      label: 'AMOUNT THRESHOLDS',
      condition: FEATURES.APPROVER_HIERARCHY__AMOUNT_THRESHOLDS,
      component: <AmountThresholdTab user={user} userAccess={userAccess} />
    },
    {
      id: 'policies',
      label: 'APPROVAL POLICIES',
      condition: FEATURES.APPROVER_HIERARCHY__APPROVAL_POLICIES,
      component: <ApprovalPolicyTab user={user} userAccess={userAccess} />
    },
    {
      id: 'employee-trans',
      label: 'EMPLOYEE TRANS. APPROVERS',
      condition: FEATURES.APPROVER_HIERARCHY__EMPLOYEE_TRANSACTION_APPROVERS,
      component: <EmployeeTransactionApprover user={user} userAccess={userAccess} />
    }
  ], [user, userAccess]); // Re-memoize only if user data changes

  // MODIFIED: Filter tabs based on feature flags
  const activeTabs = tabConfigs.filter(tab => tab.condition);

  const tabStyle = (index) => `px-4 py-2 cursor-pointer font-medium transition-colors outline-none select-none ${selectedTab === index
    ? "bg-[#668fca] text-white rounded-t-lg"
    : "text-[#668fca] hover:text-[#4a6ea5]"
    }`;

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TransactionInfo shadow-xl">
            <div className="transaction-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Transactions > "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Approver Hierarchy"}
                </span>
              </div>
              <h3>Approver Hierarchy</h3>
            </div>

            <div className="mainData p-5">
              <Tabs
                selectedIndex={selectedTab}
                onSelect={index => handleSelectChange(index)}
                className="react-tabs"
              >
                {/* MODIFIED: Dynamically render Tab Headers */}
                <TabList
                  className="flex flex-row items-center justify-start overflow-x-auto overflow-y-hidden text-sm border-b border-gray-200 mb-4 list-none p-0"
                  style={{ borderBottom: '1px solid #dadce0' }}
                >
                  {activeTabs.map((tab, index) => (
                    <Tab key={tab.id} className={tabStyle(index)}>
                      {tab.label}
                    </Tab>
                  ))}
                </TabList>

                <div className="requestApprovalTab">
                  {/* MODIFIED: Dynamically render Tab Content Panels */}
                  {activeTabs.map((tab) => (
                    <TabPanel key={tab.id}>
                      {tab.component}
                    </TabPanel>
                  ))}
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApproverHierarchy;